import { createApp } from 'utils/vue';
import App from "components/pdf_viewer/container_sample";
import { registerHandler } from "utils/handler";

const handler = (app) => {
  createApp(App, app.data).mount("#app-container");
};

registerHandler("samples/pdf_viewer/index", handler);
